var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueEditor',{attrs:{"editorToolbar":_vm.customToolbar},model:{value:(_vm.texto),callback:function ($$v) {_vm.texto=$$v},expression:"texto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }